//toda vez que precisamos alterar uma informação passamos pelo reducer
//primeira coisa que criamos é uma interface para tipar os dados que teremos na store
//criar interface dentro do reducer

import { createReducer, on } from '@ngrx/store';
import { IProfessionalService } from 'src/app/shared/interfaces/profissional/iprofessionalservice';
import { deleteProfessionalService, deleteProfessionalServiceError, deleteProfessionalServiceSuccess, editProfessionalService, editProfessionalServiceError, editProfessionalServiceSuccess, loadProfessionalService, loadProfessionalServiceByIdProfessional, loadProfessionalServiceSuccess, saveProfessionalService, saveProfessionalServiceError, saveProfessionalServiceSuccess } from './professional-service.actions';


export interface IProfessionalServiceState {
  lista: IProfessionalService[];
  type: string | null;
  action: string;
}

const initialState: IProfessionalServiceState = {
  lista: [],
  type: null,
  action: "get"
};

export const professionalServiceReducer = createReducer(
  initialState,
  on(loadProfessionalService, (state) => ({
    ...state,
    type: "loading",
    action: "get"
  })),
  on(loadProfessionalServiceByIdProfessional, (state) => ({
    ...state,
    type: "loading",
    action: "get"
  })),
  on(loadProfessionalServiceSuccess, (state, { lista }) => ({
    ...state,
    type: "success",
    action: "get",
    lista: lista,
  })),
  on(saveProfessionalService, (state) => ({
    ...state,
    type: "loading",
    action: "save"
  })),
  on(saveProfessionalServiceSuccess, (state, { professionalService }) => ({
    ...state,
    type: "success",
    action: "save",
    lista: [...state.lista, professionalService],
  })),
  on(saveProfessionalServiceError, (state) => ({
    ...state,
    type: "error",
    action: "save",
  })),
  on(editProfessionalService, (state) => ({
    ...state,
    type: "loading",
    action: "edit"
  })),
  on(editProfessionalServiceSuccess, (state, { professionalService }) => ({
    ...state,
    type: "success",
    action: "edit",
    lista: [...state.lista],
  })),
  on(editProfessionalServiceError, (state) => ({
    ...state,
    type: "error",
    action: "edit",
  })),
  on(deleteProfessionalService, (state) => ({
    ...state,
    type: "loading",
    action: "delete",
  })),
  on(deleteProfessionalServiceSuccess, (state) => ({
    ...state,
    type: "success",
    action: "delete",
  })),
  on(deleteProfessionalServiceError, (state) => ({
    ...state,
    type: "error",
    action: "delete",
  }))
);
//colocar como parametro o professionalReducer lá no app.module
//agora criamos o selector em um novo arquivo
